import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

import { downloadLicense } from "../../store/licenses-actions";

import { useDispatch, useSelector } from "react-redux";

const ViewLicenseDetials = (props) => {
  const license = useSelector((state) => state.licenses.selectedLicense);
  const dispatch = useDispatch();

  const downloadHandler = async () => dispatch(downloadLicense(license.id));

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">License details</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          License content and its public key. Download license to install it manualy on target system.
        </DialogContentText>
        {/* <TextField
          margin="dense"
          id="licenseKey"
          label="License Key"
          type="text"
          fullWidth
          multiline
          variant="outlined"
          rows={6}
          value={license?.publicKey}
        /> */}
        <TextField
          margin="dense"
          id="licenseContent"
          label="License"
          type="text"
          fullWidth
          multiline
          variant="outlined"
          rows={12}
          value={license?.licenseText}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={downloadHandler} color="primary">
          Download
        </Button>
        <Button onClick={props.onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewLicenseDetials;
